import { render, staticRenderFns, recyclableRender, components } from "./rich-text.vue?vue&type=template&id=787afe78&scoped=true&"
var renderjs
import script from "./rich-text.vue?vue&type=script&lang=js&"
export * from "./rich-text.vue?vue&type=script&lang=js&"
import style0 from "./rich-text.vue?vue&type=style&index=0&id=787afe78&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../soft/HBuilderX/plugins/uniapp-cli/node_modules/@dcloudio/vue-cli-plugin-uni/packages/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "787afe78",
  null,
  false,
  components,
  renderjs
)

component.options.__file = "pages/rich-text/rich-text.vue"
export default component.exports